import { render } from "./Conclude.vue?vue&type=template&id=37b7350e"
import script from "./Conclude.vue?vue&type=script&lang=js"
export * from "./Conclude.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__